<template>
  <div class="banner-wrapper">
    <el-carousel height="44vw" arrow="hover" indicator-position="none">
      <el-carousel-item v-for="(item, index) in bannerList" :key="index">
        <img :src="item.image" style="width: 100%; height: 100%; object-fit: cover" />
        <div class="banner-box">
          <div class="title">{{ item.name }}</div>
          <div class="more" @click="toDetail(item)" v-if="$route.query.id == 1">
            <div class="text">了解更多</div>
            <div class="arrow-right"></div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bannerList: [],
    };
  },
  methods: {
    toDetail(item) {
      if (item.id == 1) {
        this.$router.push({
          path: '/aboutUs',
          query: {
            id: 5,
          }
        })
      }
    },
    getBanner() {
      this.axios
        .post("/api/index/getBanner", { position_id: this.$route.query.id || 1 })
        .then((res) => {
          this.bannerList = res;
          this.bannerList.forEach((item) => {
            item.image = "https://admin.syljhky.com//" + item.image;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    $route() {
      this.getBanner()
    }
  },
  created() {
    this.getBanner();
  },
};
</script>

<style lang="scss" scoped>
.banner-wrapper {
  width: 100%;
  box-sizing: border-box;
  position: relative;

  .banner-box {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    text-align: left;
    max-width: 1200px;

    .title {
      font-weight: bold;
      font-size: 56px;
      color: #FFFFFF;
      margin-bottom: 20px;
      line-height: 1.2;
    }

    .more {
      display: flex;
      align-items: center;
      cursor: pointer;

      .text {
        font-size: 18px;
        color: #FFFFFF;
        margin-right: 10px;
      }

      .arrow-right {
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 10px solid #fff;
      }
    }
  }
}

@media (max-width: 576px) {
  .banner-wrapper .banner-box {
    top: 60%;
  }

  .banner-wrapper .banner-box .title {
    font-size: 22px;
    margin-bottom: 5px;
  }

  .banner-wrapper .banner-box .more .text {
    font-size: 14px;
  }
}

@media (max-width: 768px) {
  .banner-wrapper {
    padding: 0 15px;
  }

  .banner-wrapper .banner-box {
    top: 55%;
  }

  .banner-wrapper .banner-box .title {
    font-size: 26px;
  }
}

@media (max-width: 992px) {
  .banner-wrapper .banner-box {
    top: 50%;
    left: 60%;
  }

  .banner-wrapper .banner-box .title {
    font-size: 34px;
  }

  .banner-wrapper .banner-box .more .text {
    font-size: 16px;
  }
}

@media (max-width: 1200px) {
  .banner-wrapper .banner-box {
    top: 48%;
  }

  .banner-wrapper .banner-box .title {
    font-size: 44px;
  }
}
</style>
